const PreviewTab = () => {
  return (
    <div style={{ margin: "10px" }}>
      <h1>Preview Tab</h1>
    </div>
  );
};

export default PreviewTab;
